export default [
  {
    path: ''
  },
  {
    path: 'login',
    name: 'BoLogin',
    component: () => import('@/views/BoLogin/IndexView.vue'),
    meta: {
      redirectIfLoggedIn: true,
      layout: 'empty'
    }
  },

  {
    path: 'dashboard',
    name: 'BoDashboard',
    component: () => import('@/views/BoDashboard.vue'),
    meta: {
      generalMenu: true,
      menu: 'BoDashboard',
      pageTitle: 'Dashboard',
      objName: 'Dashboard'
    }
  },
  {
    path: 'dashboard-resume',
    name: 'DashboardResume',
    component: () => import('@/views/DashboardResume.vue'),
    meta: {
      layout: 'empty'
    }
  },
  {
    path: 'update-profile',
    name: 'BoUpdateProfile',
    component: () => import('@/views/BoUpdateProfile.vue'),
    meta: {
      generalMenu: true,
      menu: 'BoUpdateProfile',
      pageTitle: 'Update My Profile',
      objName: 'Update My Profile'
    }
  },
  {
    path: 'notification',
    name: 'BoNotification',
    component: () => import('@/views/BoNotification.vue'),
    meta: {
      generalMenu: true,
      menu: 'BoNotification',
      pageTitle: 'Notification',
      objName: 'Notification'
    }
  },

  {
    path: 'setting/audit-trail',
    name: 'BoLogAuditTrail',
    component: () => import('@/views/BoLogAuditTrail/IndexView.vue'),
    meta: {
      menu: 'BoLogAuditTrail',
      pageTitle: 'Audit Trail',
      objName: 'Audit Trail'
    }
  },
  {
    path: 'setting/app-config',
    name: 'BoAppConfig',
    component: () => import('@/views/BoAppConfig/IndexView.vue'),
    meta: {
      menu: 'BoAppConfig',
      pageTitle: 'Konfigurasi App',
      objName: 'Konfigurasi'
    }
  },

  {
    path: 'setting/user/:pageSlug?/:pageId?',
    name: 'BoUser',
    component: () => import('@/views/BoUser/IndexView.vue'),
    meta: {
      menu: 'BoUser',
      pageTitle: 'User',
      objName: 'User'
    }
  },
  {
    path: 'setting/user-level/:pageSlug?/:pageId?',
    name: 'BoUserLevel',
    component: () => import('@/views/BoUserLevel/IndexView.vue'),
    meta: {
      menu: 'BoUserLevel',
      pageTitle: 'Access Level',
      objName: 'Access Level'
    }
  },

  {
    path: 'setting/master/jenis-karung/:pageSlug?/:pageId?',
    name: 'BoMrJenisKarung',
    component: () => import('@/views/BoMaster/BoMrJenisKarung/IndexView.vue'),
    meta: {
      menu: 'BoMrJenisKarung',
      pageTitle: 'Jenis Karung',
      objName: 'Jenis Karung'
    }
  },
  {
    path: 'setting/master/potongan-harga/:pageSlug?/:pageId?',
    name: 'BoMrPotonganHarga',
    component: () => import('@/views/BoMaster/BoMrPotonganHarga/IndexView.vue'),
    meta: {
      menu: 'BoMrPotonganHarga',
      pageTitle: 'Potongan Harga',
      objName: 'Potongan Harga'
    }
  },
  {
    path: 'setting/master/notifikasi/:pageSlug?/:pageId?',
    name: 'BoMrNotifikasi',
    component: () => import('@/views/BoMaster/BoMrNotifikasi/IndexView.vue'),
    meta: {
      menu: 'BoMrNotifikasi',
      pageTitle: 'Notifikasi',
      objName: 'Notifikasi'
    }
  },
  {
    path: 'setting/master/truck/:pageSlug?/:pageId?',
    name: 'BoMrTruck',
    component: () => import('@/views/BoMaster/BoMrTruck/IndexView.vue'),
    meta: {
      menu: 'BoMrTruck',
      pageTitle: 'Truk',
      objName: 'Truk'
    }
  },
  {
    path: 'setting/master/template-dokumen/:pageSlug?/:pageId?',
    name: 'BoMrTemplateDokumen',
    component: () => import('@/views/BoMaster/BoMrTemplateDokumen/IndexView.vue'),
    meta: {
      menu: 'BoMrTemplateDokumen',
      pageTitle: 'Template Dokumen',
      objName: 'Template Dokumen'
    }
  },
  {
    path: 'setting/master/product/:pageSlug?/:pageId?',
    name: 'BoMrProduct',
    component: () => import('@/views/BoMaster/BoMrProduct/IndexView.vue'),
    meta: {
      menu: 'BoMrProduct',
      pageTitle: 'Produk',
      objName: 'Produk'
    }
  },
  {
    path: 'setting/master/konversi-berat/:pageSlug?/:pageId?',
    name: 'BoMrKonversiBerat',
    component: () => import('@/views/BoMaster/BoMrKonversiBerat/IndexView.vue'),
    meta: {
      menu: 'BoMrKonversiBerat',
      pageTitle: 'Konversi Berat',
      objName: 'Konversi Berat'
    }
  },
  {
    path: 'petugas/supir/:pageSlug?/:pageId?',
    name: 'BoAppPetugasSupir',
    component: () => import('@/views/BoPetugas/BoAppPetugasSupir/IndexView.vue'),
    meta: {
      menu: 'BoAppPetugasSupir',
      pageTitle: 'Petugas Supir',
      objName: 'Petugas Supir'
    }
  },
  {
    path: 'petugas/gudang/:pageSlug?/:pageId?',
    name: 'BoAppPetugasGudang',
    component: () => import('@/views/BoPetugas/BoAppPetugasGudang/IndexView.vue'),
    meta: {
      menu: 'BoAppPetugasGudang',
      pageTitle: 'Petugas Gudang',
      objName: 'Petugas Gudang'
    }
  },
  {
    path: 'petugas/keuangan/:pageSlug?/:pageId?',
    name: 'BoAppPetugasKeuangan',
    component: () => import('@/views/BoPetugas/BoAppPetugasKeuangan/IndexView.vue'),
    meta: {
      menu: 'BoAppPetugasKeuangan',
      pageTitle: 'Petugas Keuangan',
      objName: 'Petugas Keuangan'
    }
  },
  {
    path: 'petugas/kordes/:pageSlug?/:pageId?',
    name: 'BoAppPetugasKordes',
    component: () => import('@/views/BoPetugas/BoAppPetugasKordes/IndexView.vue'),
    meta: {
      menu: 'BoAppPetugasKordes',
      pageTitle: 'Petugas Kordes',
      objName: 'Petugas Kordes'
    }
  },
  {
    path: 'titik-kumpul/:pageSlug?/:pageId?',
    name: 'BoAppTitikKumpul',
    component: () => import('@/views/BoAppTitikKumpul/IndexView.vue'),
    meta: {
      menu: 'BoAppTitikKumpul',
      pageTitle: 'Titik Kumpul',
      objName: 'Titik Kumpul'
    }
  },
  {
    path: 'peternak/:pageSlug?/:pageId?',
    name: 'BoAppPeternak',
    component: () => import('@/views/BoAppPeternak/IndexView.vue'),
    meta: {
      menu: 'BoAppPeternak',
      pageTitle: 'Peternak',
      objName: 'Peternak'
    }
  },
  {
    path: 'peternak-blacklist/:pageSlug?/:pageId?',
    name: 'BoAppPeternakBlacklist',
    component: () => import('@/views/BoAppPeternakBlacklist/IndexView.vue'),
    meta: {
      menu: 'BoAppPeternakBlacklist',
      pageTitle: 'Peternak Blacklist',
      objName: 'Peternak Blacklist'
    }
  },
  {
    path: 'kuesioner-peternak/:pageSlug?/:pageId?',
    name: 'BoAppKuesionerPeternak',
    component: () => import('@/views/BoAppKuesionerPeternak/IndexView.vue'),
    meta: {
      menu: 'BoAppKuesionerPeternak',
      pageTitle: 'Kuesioner Peternak',
      objName: 'Kuesioner Peternak'
    }
  },
  {
    path: 'verifikasi-peternak/:pageSlug?/:pageId?',
    name: 'BoAppVerifikasiPeternak',
    component: () => import('@/views/BoAppVerifikasiPeternak/IndexView.vue'),
    meta: {
      menu: 'BoAppVerifikasiPeternak',
      pageTitle: 'Verifikasi Peternak',
      objName: 'Verifikasi Peternak'
    }
  },
  {
    path: 'verifikasi-paket/:pageSlug?/:pageId?',
    name: 'BoAppVerifikasiPenambahanPaket',
    component: () => import('@/views/BoAppVerifikasiPenambahanPaket/IndexView.vue'),
    meta: {
      menu: 'BoAppVerifikasiPenambahanPaket',
      pageTitle: 'Verifikasi Penambahan Paket',
      objName: 'Verifikasi Penambahan Paket'
    }
  },
  {
    path: 'tanggal-panen/:pageSlug?/:pageId?',
    name: 'BoEstimasiPanen',
    component: () => import('@/views/BoEstimasiPanen/IndexView.vue'),
    meta: {
      menu: 'BoEstimasiPanen',
      pageTitle: 'Estimasi Tgl Panen',
      objName: 'Estimasi Tgl Panen'
    }
  },
  {
    path: 'peta-sebaran/:pageSlug?/:pageId?',
    name: 'BoPetaSebaran',
    component: () => import('@/views/BoPetaSebaran/IndexView.vue'),
    meta: {
      menu: 'BoPetaSebaran',
      pageTitle: 'Peta Sebaran',
      objName: 'Peta Sebaran'
    }
  },
  {
    path: 'chat/:pageSlug?/:pageId?',
    name: 'BoTrxChat',
    component: () => import('@/views/BoChat/IndexView.vue'),
    meta: {
      menu: 'BoTrxChat',
      pageTitle: 'Chat',
      objName: 'Chat'
    }
  },
  {
    path: 'chat-group/:pageSlug?/:pageId?',
    name: 'BoTrxChatGroup',
    component: () => import('@/views/BoChatGroup/IndexView.vue'),
    meta: {
      menu: 'BoTrxChatGroup',
      pageTitle: 'Chat Group',
      objName: 'Chat Group'
    }
  },
  {
    path: 'transaksi-panen/:pageSlug?/:pageId?',
    name: 'BoTrxPanen',
    component: () => import('@/views/BoTrxPanen/IndexView.vue'),
    meta: {
      menu: 'BoTrxPanen',
      pageTitle: 'Transaksi Panen',
      objName: 'Transaksi Panen'
    }
  },
  {
    path: 'tugas-supir/:pageSlug?/:pageId?',
    name: 'BoTrxTugasSupir',
    component: () => import('@/views/BoTrxTugasSupir/IndexView.vue'),
    meta: {
      menu: 'BoTrxTugasSupir',
      pageTitle: 'Transaksi Tugas Supir',
      objName: 'Transaksi Tugas Supir'
    }
  },
  {
    path: 'konfirmasi-pembayaran/:pageSlug?/:pageId?',
    name: 'BoTrxKonfirmasiPembayaran',
    component: () => import('@/views/BoTrxKonfirmasiPembayaran/IndexView.vue'),
    meta: {
      menu: 'BoTrxKonfirmasiPembayaran',
      pageTitle: 'Konfirmasi Pembayaran',
      objName: 'Konfirmasi Pembayaran'
    }
  },
  {
    path: 'laporan-hasil-panen/:pageSlug?/:pageId?',
    name: 'BoLaporanHasilPanen',
    component: () => import('@/views/BoLaporan/BoLaporanHasilPanen/ListView.vue'),
    meta: {
      menu: 'BoLaporanHasilPanen',
      pageTitle: 'Laporan Hasil Panen',
      objName: 'Laporan Hasil Panen'
    }
  },
  {
    path: 'laporan-kunjungan-kordes/:pageSlug?/:pageId?',
    name: 'BoLaporanKunjunganKordes',
    component: () => import('@/views/BoLaporan/BoLaporanKunjunganKordes/ListView.vue'),
    meta: {
      menu: 'BoLaporanKunjunganKordes',
      pageTitle: 'Laporan Kunjungan Kordes',
      objName: 'Laporan Kunjungan Kordes'
    }
  },
  {
    path: 'laporan-absen-kordes/:pageSlug?/:pageId?',
    name: 'BoLaporanAbsenKordes',
    component: () => import('@/views/BoLaporan/BoLaporanAbsenKordes/ListView.vue'),
    meta: {
      menu: 'BoLaporanAbsenKordes',
      pageTitle: 'Laporan Absen Kordes',
      objName: 'Laporan Absen Kordes'
    }
  },
  {
    path: 'data-peternak/:pageSlug?/:pageId?',
    name: 'BoLaporanDataPeternak',
    component: () => import('@/views/BoLaporan/BoLaporanDataPeternak/ListView.vue'),
    meta: {
      menu: 'BoLaporanDataPeternak',
      pageTitle: 'Laporan Data Peternak',
      objName: 'Laporan Data Peternak'
    }
  }, 
  {
    path: 'data-pembayaran/:pageSlug?/:pageId?',
    name: 'BoLaporanPembayaran',
    component: () => import('@/views/BoLaporan/BoLaporanPembayaran/ListView.vue'),
    meta: {
      menu: 'BoLaporanPembayaran',
      pageTitle: 'Laporan Pembayaran',
      objName: 'Laporan Pembayaran'
    }
  }, 
  {
    path: 'stock-vermicompost/:pageSlug?/:pageId?',
    name: 'BoStockVermiCompost',
    component: () => import('@/views/BoStockVermiCompost/IndexView.vue'),
    meta: {
      menu: 'BoStockVermiCompost',
      pageTitle: 'Stock Vermicompost',
      objName: 'Stock Vermicompost'
    }
  }
] 
